
define('text!libs/strand/src/strand-model/index.html',[],function () { return '<!DOCTYPE html>\n<html>\n  <head>\n\t<script language="javascript" src="../../bower_components/webcomponentsjs/webcomponents.js"></script>\n    <link rel="import" href="strand-model.html">\n  </head>\n  <body>\n    <strand-model></strand-model>\n  </body>\n</html>';});

